import React from "react";
import ParticlesBg from "particles-bg";
import { Container } from "@mui/material";
import NavMenu from "./Menu";
import "../utils/style.css";
import axios from "axios";
import StyledButton from "../utils/StyledButton";

export default class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      from: "",
      subject: "",
      message: "",
      active: (props.locked && props.active) || false,
      value: props.value || "",
      error: props.error || ""
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  changeValue(event) {
    const value = event.target.value;
    this.setState({ value, error: "" });
  }

  handleKeyPress(event) {
    if (event.which === 1) {
      this.setState({ value: this.props.predicted });
    }
  }

  handleSubmit = async () => {
    const data = {
      from: this.state.from,
      subject: this.state.subject,
      message: this.state.message,
      name: this.state.name,
    };
     await axios
      .post("/email", data)
      .then((response) => {
        if (response.data.message) {
          console.log("Success: " + response.data.message);
        } else if (response.data.statusCode) {
          console.log("Failed: " + response.data.statusCode);
        }
      })
      .catch((error) => {
        console.log(error.response);
      });
  }
  
  render() {
    const { active, value, error } = this.state;
    const { predicted, locked } = this.props;
    const fieldClassName = `field ${ (locked ? active : active || value) && "active"
    } ${locked && !active && "locked"}`;

    return (
      <>
        <NavMenu />
        <ParticlesBg type="circle" bg={true} />
        <Container maxWidth="sm">
        <br></br>
          <h1>Knight's Kennel </h1>
          <p>

            🐶 Get in touch! Have a question for us? Maybe some feedback? We
            love talking about Miniature Schnauzers, and we're happy to answer
            questions about our pricing, our bloodlines, our breeding practices
            or anything else you'd like to know. Send us a note and we'll get
            back to you as soon as possible.
            <span className="dog">🐶</span>
          </p>

          <div className={fieldClassName}>
            {active && value && predicted && predicted.includes(value) && (
              <p className="predicted">{predicted}</p>
            )}
            <input
              id={1}
              label="Name"
              type="text"
              value={this.state.name}
              placeholder="Name"
              onChange={(e) => this.setState({ name: e.target.value })}
              onKeyPress={this.handleKeyPress.bind(this)}
              onFocus={() => !locked && this.setState({ active: true })}
              onBlur={() => !locked && this.setState({ active: false })}
            />
            <label htmlFor={1} className={error && "error"}>
              {error || "Name"}
            </label>
          </div>

          <div className={fieldClassName}>
            {active && value && predicted && predicted.includes(value) && (
              <p className="predicted">{predicted}</p>
            )}
            <input
              id={2}
              label="Email"
              type="text"
              value={this.state.from}
              placeholder="Email"
              onChange={(e) => this.setState({ from: e.target.value })}
              onKeyPress={this.handleKeyPress.bind(this)}
              onFocus={() => !locked && this.setState({ active: true })}
              onBlur={() => !locked && this.setState({ active: false })}
            />
            <label htmlFor={2} className={error && "error"}>
              {error || "Email"}
            </label>
          </div>
          <div className={fieldClassName}>
            {active && value && predicted && predicted.includes(value) && (
              <p className="predicted">{predicted}</p>
            )}
            <input
              id={3}
              label="Subject"
              type="text"
              value={this.state.subject}
              placeholder="Subject"
              onChange={(e) => this.setState({ subject: e.target.value })}
              onKeyPress={this.handleKeyPress.bind(this)}
              onFocus={() => !locked && this.setState({ active: true })}
              onBlur={() => !locked && this.setState({ active: false })}
            />
            <label htmlFor={3} className={error && "error"}>
              {error || "Subject"}
            </label>
          </div>

          <textarea
            id="test-mailing"
            name="test-mailing"
            onChange={(e) => this.setState({ message: e.target.value })}
            placeholder="Post some question here"
            required
            style={{ width: "100%", height: "150px" }}
          />

          <form ref="form" onSubmit={this.handleSubmit}>
            <StyledButton />
          </form>

          <h2>
            Breeders of high quality AKC Miniature Schnauzers in Rhode Island
          </h2>
        </Container>
      </>
    );
  }

 

  // POST('/email', this.state, function() {
  //         console.log('Server recieved our data');
  // });
}
